/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */
import _Number$isNaN from "@babel/runtime-corejs3/core-js-stable/number/is-nan";

/** @module core/modules/date-utils/is-valid-date */

/**
 * @description Returns true if the input is a valid date and false otherwise.
 * @param {*} input - Input value.
 * @returns {boolean} Result.
 */
function isValidDate(input) {
  return input instanceof Date && !_Number$isNaN(input.getTime());
}

export { isValidDate };